import React, { useState } from 'react';
import { Box } from '@mui/material';
import Header from '../../Common/Header/Header';
import PermanenceWrapper from './Permanence';
import TotalsWrapper from './Totals';
import ServicesWrapper from '../Common/Services/page';
import { QUERY_KEYS_SIH } from '../../Common/hooks/useChartsData';
import { subtitlesMap } from '../Common/maps/subtitleMap';
import ChartsContainer from '../../Common/ChartsContainer';

const titleMap = {
    0: 'Totais - Permanência e Acomodação',
    1: 'Média de Dias de Permanência',
    2: 'Total de AIH por Caráter de Internação',
    3: 'Total de AIH por Complexidade'
};

const renderContent = (activeIndex) => {
    switch (activeIndex) {
        case 0:
            return <TotalsWrapper />;
        case 1:
            return <PermanenceWrapper />;
        case 2:
            return (
                <ServicesWrapper
                    module={{
                        sectionTitle: 'do Total de AIH por Caráter de Internação'
                    }}
                    queryConfig={{
                        key: QUERY_KEYS_SIH.CHARACTER_OF_ADMISSSION,
                        url: 'governanceroom/dashboard/sihsus/aih/hospitalizationTypes'
                    }}
                    subtitlesMap={subtitlesMap}
                />
            );
        case 3:
            return (
                <ServicesWrapper
                    module={{ sectionTitle: 'do Total de AIH por Complexidade' }}
                    queryConfig={{
                        key: QUERY_KEYS_SIH.COMPLEXETY_LEVEL,
                        url: 'governanceroom/dashboard/sihsus/aih/hospitalizationComplexity'
                    }}
                    subtitlesMap={subtitlesMap}
                />
            );
        default:
            return null;
    }
};

export const Hospitalization = ({ setActiveIndex }) => {
    const [activeIndexLocal, setActiveIndexLocal] = useState(0);

    const handleHomeClick = () => {
        if (setActiveIndex) {
            setActiveIndex(0);
        }

        setActiveIndexLocal(0);
    };

    const menus = [
        {
            title: 'Totais',
            onclick: () => setActiveIndexLocal(0),
            active: activeIndexLocal === 0
        },
        {
            title: 'Permanência',
            onclick: () => setActiveIndexLocal(1),
            active: activeIndexLocal === 1
        },
        {
            title: 'Caráter de Internação',
            onclick: () => setActiveIndexLocal(2),
            active: activeIndexLocal === 2
        },
        {
            title: 'Complexidade',
            onclick: () => setActiveIndexLocal(3),
            active: activeIndexLocal === 3
        }
    ];

    return (
        <Box className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[activeIndexLocal]}
                    className="services-container-dashboards"
                >
                    {renderContent(activeIndexLocal)}
                </ChartsContainer>
            </Box>
        </Box>
    );
};
